import clsx from 'clsx';
import React from 'react';

import { CommentUser } from '../../utils/backend-api/comments';
import UserProfileLink from '../User/UserProfileLink';
import { userName } from '../User/userHelpers';

export default function CommentAvatar({
  user,
  className,
}: {
  user: CommentUser;
  className?: string;
}) {
  const name = userName(user);
  return (
    <UserProfileLink user={user} className={clsx('comment-avatar-link', className)}>
      {user.picture_url ? (
        <img src={user.picture_url} alt={name} className="comment-avatar" />
      ) : (
        <div className="comment-avatar">
          <div className="comment-avatar-placeholder">{name ? name[0].toUpperCase() : ''}</div>
        </div>
      )}
    </UserProfileLink>
  );
}
